export default "https://cdn-static.gokick.com/assets/e693edcab6ba034c0ea6bea85be7a795ed1fbf27/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";